<template>
  <v-sheet>
    <v-container class="py-4 py-lg-8">
      <div class="branch p-3">
        <h4 class="text-h4 text-md-h4">
          {{ title }}</h4>
      </div>

      <v-responsive max-width="1200" class="mx-auto">
        <div class="mt-4">{{ subtitle }}</div>
      </v-responsive>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    faq: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      panel: [0]
    }
  }
}
</script>

<style scoped>
.branch{
  border-left: 4px solid #4CAF50;
}
</style>
